import { render, staticRenderFns } from "./feed.vue?vue&type=template&id=5915827e&scoped=true&"
import script from "./feed.vue?vue&type=script&lang=ts&"
export * from "./feed.vue?vue&type=script&lang=ts&"
import style0 from "./feed.vue?vue&type=style&index=0&id=5915827e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5915827e",
  null
  
)

export default component.exports